<template>
  <div class="content">
    <el-form :model="addForm"
             label-width="100px"
             style="width: 520px;">
      <el-form-item label="封面图片">
        <el-upload :action="imgUpload"
                   :class="{disabled:uploadDisabled}"
                   list-type="picture-card"
                   :on-preview="handlePictureCardPreview"
                   :on-success="handlePictureSuccess"
                   :on-remove="handleRemove"
                   :before-upload="beforeAvatarUpload"
                   :file-list="imgList">
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%"
               :src="dialogImageUrl"
               alt="">
        </el-dialog>
      </el-form-item>
      <el-form-item label="配置文件">
        <el-upload :action="imgUpload"
                   :class="{disabled:uploadDisabledFile}"
                   :on-success="handleFileSuccess"
                   :on-remove="handleRemoveFile"
                   :before-upload="beforeUploadFile"
                   :file-list="fileList"
                   multiple
                   :limit="1">
          <el-button size="small"
                     type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   @click="onConfirm"
                   :loading="commiting">添加</el-button>
        <el-button @click="$router.go(-1)"
                   :loading="commiting">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from 'axios';
import api from '../api/api';

export default {
  name: 'add',
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      uploadDisabled: false,
      dialogVisibleFile: false,
      imgUpload: `${api.url}upload`,
      uploadDisabledFile: false,
      fileList: [],
      img: '',
      imgList: [],
      addForm: {},
      commiting: false,
    };
  },
  methods: {
    handleRemove() {
      this.uploadDisabled = false;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handlePictureSuccess(file) {
      if (file.ret === 0) {
        this.uploadDisabled = true;
        this.img = file.url;
        this.addForm.img = file.url;
      } else {
        this.$message.error('上传失败，请重新上传~');
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 格式');
      }
    },
    handleFileSuccess(file) {
      if (file.ret === 0) {
        this.file = file.url;
        this.addForm.file = file.url;
      } else {
        this.$message.error('上传失败，请重新上传~');
      }
    },
    beforeUploadFile(file) {
      const extension = file.name.split('.')[1] === 'json';
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!extension) {
        this.$message.error('上传模板只能是 json 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传模板大小不能超过 10MB!');
      }
    },
    onConfirm() {
      axios.post(`${api.url}templateCreate`, this.addForm).then((response) => {
        if (response.data.ret === 0) {
          this.$message({
            type: 'success',
            message: '添加成功',
          });
          this.$router.go(-1);
        } else if (response.data.ret === 1) {
          this.$message({
            type: 'error',
            message: response.data.content,
          });
        }
      });
    },
  },
};
</script>

<style>
.disabled .el-upload--picture-card {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/addTemplate.vue